export const parseQueryParamsFromURL = paramNames => {
  const allQueryParams = new URLSearchParams(window.location.search);
  const parsedQueryParams = {};
  paramNames.forEach(paramName => {
    parsedQueryParams[paramName] = allQueryParams.get(paramName);
  });
  return parsedQueryParams;
};
